module.exports = __webpack_public_path__ + "3708c3f8bfc684056813051e2cfedfb2.svg";